// extracted by mini-css-extract-plugin
export default {"paginator":"paginator_paginator__dUV7q","paginator_text":"paginator_paginator_text__SVAbb","paginator_page_number":"paginator_paginator_page_number__mHRwQ"};